import { tsValidateArray, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { smartDocExternalParamType, smartDocParamType_Dynamic, smartDocParamType_EHR, smartDocParamType_External, smartDocParamType_Static, smartDocStaticParamTypes, Validator_SmartDocParameter } from '../../_enum/index.js';
import { DBDef_Tag, DBDef_Variable, knowledgeManagerDBGroup } from '@app/hcs-shared';
export const logTemplate_allowedParamTypes = [smartDocParamType_Static,
    smartDocParamType_Dynamic,
    smartDocParamType_External,
    smartDocParamType_EHR];
export const logTemplate_allowedSubTypes = {
    [smartDocParamType_Static]: [...smartDocStaticParamTypes],
    [smartDocParamType_External]: [...smartDocExternalParamType],
};
const Validator_ModifiableProps = {
    label: tsValidateString(),
    title: tsValidateString(),
    sections: tsValidateArray(tsValidateString()),
    params: tsValidateArray(Validator_SmartDocParameter(logTemplate_allowedParamTypes, logTemplate_allowedSubTypes)),
};
const Validator_GeneratedProps = {
    _variableIds: tsValidateArray(tsValidateUniqueId),
    _tagIds: tsValidateArray(tsValidateUniqueId),
    _logTemplateIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_LogTemplate = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'log-template',
    entityName: 'Log Template',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'log-template'
    },
    backend: {
        name: 'log-template'
    },
    generatedProps: ['_tagIds', '_variableIds', '_logTemplateIds'],
    dependencies: {
        _tagIds: {
            dbKey: DBDef_Tag.dbKey,
            fieldType: 'string[]',
        },
        _variableIds: {
            dbKey: DBDef_Variable.dbKey,
            fieldType: 'string[]',
        },
        _logTemplateIds: {
            dbKey: 'log-template',
            fieldType: 'string[]',
        }
    },
};
//# sourceMappingURL=db-def.js.map